import React from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { ExternalLink } from 'lucide-react';

const PortfolioSection = () => {
  const portfolioItems = [
    {
      id: 1,
      title: "Landing Page for Author website",
      subtitle: "logart.shop",
      url: "https://logart.shop",
      image: "/portfolio/logart-shop.png"
    },
    {
      id: 2,
      title: "Fullstack App for Vacation Property Rental Platform",
      subtitle: "holidayhomes.top",
      url: "https://holidayhomes.top",
      image: "/portfolio/holidayhomes-top.png"
    },
    {
      id: 3,
      title: "Landing Page for Orchestra Administration Platform",
      subtitle: "orkesteradmin.se",
      url: "https://orkesteradmin.se",
      image: "/portfolio/orkesteradmin-se.png"
    }
  ];

  return (
    <section 
      id="portfolio"
      style={{
        background: '#000000',
        padding: '100px 7.6923%',
        position: 'relative'
      }}
    >
      <div 
        style={{
          maxWidth: '1400px',
          margin: '0 auto'
        }}
      >
        {/* Section Header */}
        <div 
          style={{
            textAlign: 'center',
            marginBottom: '60px'
          }}
        >
          <h2 
            className="display-large"
            style={{
              marginBottom: '20px'
            }}
          >
            Portfolio
          </h2>
          <div 
            style={{
              width: '60px',
              height: '3px',
              background: '#00FFD1',
              margin: '0 auto'
            }}
          />
          <p
            style={{
              color: '#B0B0B0',
              fontSize: '18px',
              marginTop: '20px',
              maxWidth: '700px',
              margin: '20px auto 0'
            }}
          >
            Showcasing our recent AI-powered website projects
          </p>
        </div>

        {/* Carousel */}
        <div style={{ position: 'relative', paddingLeft: '60px', paddingRight: '60px' }}>
          <Carousel
            opts={{
              align: "start",
              loop: true,
            }}
            className="w-full"
          >
            <CarouselContent>
              {portfolioItems.map((item) => (
                <CarouselItem key={item.id} className="md:basis-1/2 lg:basis-1/2">
                  <div style={{ padding: '10px' }}>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: 'block',
                        position: 'relative',
                        background: '#121212',
                        border: '1px solid #1a1a1a',
                        borderRadius: '0px',
                        overflow: 'hidden',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        textDecoration: 'none'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.border = '1px solid #00FFD1';
                        e.currentTarget.style.transform = 'translateY(-5px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.border = '1px solid #1a1a1a';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}
                    >
                      {/* Image Container */}
                      <div 
                        style={{
                          position: 'relative',
                          width: '100%',
                          height: '400px',
                          overflow: 'hidden',
                          background: '#0a0a0a'
                        }}
                      >
                        <img
                          src={item.image}
                          alt={item.title}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'top',
                            transition: 'transform 0.3s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                          }}
                        />
                        
                        {/* Overlay on Hover */}
                        <div
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'rgba(0, 255, 209, 0.1)',
                            opacity: 0,
                            transition: 'opacity 0.3s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.opacity = '1';
                          }}
                        >
                          <div
                            style={{
                              background: '#00FFD1',
                              color: '#000000',
                              padding: '12px 24px',
                              borderRadius: '0px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              fontWeight: '600'
                            }}
                          >
                            <span>View Live Site</span>
                            <ExternalLink size={18} />
                          </div>
                        </div>
                      </div>

                      {/* Text Content */}
                      <div style={{ padding: '24px' }}>
                        <h3
                          style={{
                            color: '#FFFFFF',
                            fontSize: '20px',
                            fontWeight: '600',
                            marginBottom: '8px',
                            lineHeight: '1.4'
                          }}
                        >
                          {item.title}
                        </h3>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            color: '#00FFD1',
                            fontSize: '16px'
                          }}
                        >
                          <span>{item.subtitle}</span>
                          <ExternalLink size={16} />
                        </div>
                      </div>
                    </a>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            
            {/* Custom Styled Navigation Buttons */}
            <CarouselPrevious 
              style={{
                background: '#00FFD1',
                color: '#000000',
                border: 'none',
                borderRadius: '0px',
                width: '40px',
                height: '40px'
              }}
            />
            <CarouselNext 
              style={{
                background: '#00FFD1',
                color: '#000000',
                border: 'none',
                borderRadius: '0px',
                width: '40px',
                height: '40px'
              }}
            />
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
